import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const toggleSubAccountPublicAccess = (investor_id, amp_user_id) => request.put(`${API_BASE_URL}/blockchain/${investor_id}/sub-accounts/${amp_user_id}/toggle-public-access`)

export default toggleSubAccountPublicAccess;